
import Schema from 'AppReact/schema';
import { navigationPages } from './utils';

export default {
  pageNumber: Schema('integer', 'primitive', { defaultValue: 0 }),
  pageSize: Schema('integer', 'primitive', { defaultValue: 15 }),
  total: Schema('integer', 'primitive', { defaultValue: 0 }),
  navigationPages: Schema('integer', 'array', { defaultValue: navigationPages }),
}

